module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9591_lime_green.87ed9ceb.jpg";